import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Paper, Typography } from "@mui/material";
import { Localized } from "@fluent/react";
import { useNavigate } from "react-router-dom";

export const NoPermissionError = ({ onSupport }: { onSupport: () => void }) => {
    const navigate = useNavigate();

    return (
        <Paper
            variant="outlined"
            sx={{
                maxWidth: 700,
                mx: 'auto',
                mt: 4,
                borderRadius: 2,
                overflow: 'hidden'
            }}
        >

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    py: 5,
                    px: 3
                }}
            >
                <Box
                    sx={{
                        width: 64,
                        height: 64,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#FFF4E5',
                        mb: 2
                    }}
                >
                    <LockOutlinedIcon
                        sx={{
                            fontSize: 34,
                            color: '#B26A00'
                        }}
                    />
                </Box>

                <Typography variant="h5" fontWeight={600} gutterBottom>
                    <Localized id="error-access-denied">
                        Brak dostępu
                    </Localized>
                </Typography>

                <Typography
                    color="text.secondary"
                    sx={{ maxWidth: 520, mb: 1 }}
                >
                    <Localized id="error-no-permissions-resource-access">
                        Nie masz uprawnień, aby uzyskać dostęp do tego zasobu.
                    </Localized>
                </Typography>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ maxWidth: 520, mb: 3 }}
                >
                    <Localized id="error-solve-problem">
                        Jeżeli uważasz, że powinieneś mieć dostęp, skontaktuj się ze wsparciem.
                    </Localized>
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        gap: 1.5,
                        flexWrap: 'wrap',
                        justifyContent: 'center'
                    }}
                >
                    <Button
                        variant="contained"
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate(-1)}
                    >
                        <Localized id="back">
                            Wróć
                        </Localized>
                    </Button>

                    <Button
                        variant="outlined"
                        onClick={onSupport}
                    >
                        <Localized id="contact-support">
                            Kontakt ze wsparciem
                        </Localized>
                    </Button>
                </Box>
            </Box>
        </Paper>
    );
}; 